/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

export default function Loader() {
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
